// s911-share.js
import selfHtml from './s911-share.html' with { type: 'text' };;

import { copy_to_clipboard, show_modal, generate_qr } from "../utils.js";

var QR_ModalPanel
var root

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root;

    const share_my_pub_link = root.querySelector("input[name='share_my_pub_link']");

    share_my_pub_link.value = args.active_link;

    QR_ModalPanel = root.querySelector(".QR_ModalPanel");

    share_my_pub_link.addEventListener('click', (e) => { e.currentTarget.select() });

    root.querySelector(".copy_link_to_clipboard").addEventListener('click', (e) => copy_to_clipboard(e.currentTarget));

    root.querySelector(".btn_invite_recipient_copy").addEventListener('click', (e) => copy_to_clipboard(root.querySelector(".copy_link_to_clipboard")));

    root.querySelector(".btn_invite_recipient_qr").addEventListener('click', () => toggle_qr());

    root.querySelector(".btn_invite_recipient_email").addEventListener('click', (e => {
        const subject = args.shareData.title;
        const body = args.shareData.text + " - " + args.shareData.url;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }));

    root.querySelector(".btn_invite_recipient_teams").addEventListener('click', (e => {
        const url = encodeURIComponent(args.shareData.url);
        const text = encodeURIComponent(args.shareData.text);
        const teamsShareUrl = `https://teams.microsoft.com/share?href=${url}&msgText=${text}`;
        window.open(teamsShareUrl, "_blank", "noopener,noreferrer");
    }));

    root.querySelector(".btn_invite_recipient_whatsapp").addEventListener('click', (e => {
        const url = 'https://web.whatsapp.com/send?text=' + encodeURIComponent(args.shareData.text + " - " + args.shareData.url);
        window.location.href = url;
    }));

    root.querySelector(".btn_invite_recipient_snapchat").addEventListener('click', (e => {
        const url = encodeURIComponent(args.shareData.url); // SnapChat doesn't support text on the link
        const snapchatShareUrl = `https://www.snapchat.com/share?link=${url}`;
        window.open(snapchatShareUrl, "_blank", "noopener,noreferrer");
    }));

    root.querySelector(".btn_invite_recipient_telegram").addEventListener('click', (e => {
        const url = 'https://t.me/share/url?url=' + encodeURIComponent(args.shareData.url) + '&text=' + encodeURIComponent(args.shareData.text);
        window.location.href = url;
    }));

    activate_share(root, args.shareData)

    generate_qr(args.shareData.url, QR_ModalPanel)
}

// ----------------------------------------------------------------------------------

function activate_share(root, shareData) {

    const btn = root.querySelector(".btn_invite_recipient_share")

    const resultPara = document.querySelector(".share_result");

    // Share must be triggered by "user activation"
    btn.addEventListener("click", async () => {
        try {
            if (!navigator.share)
                return show_modal("Cannot share", "Your browser doesn't support the 'share' feature.")
            await navigator.share(shareData);
            console.log("MDN shared successfully");
        } catch (err) {
            console.log(`Error: ${err}`);
        }
    });

}

// ----------------------------------------------------------------------------------

async function toggle_qr() {

    if (QR_ModalPanel.classList.contains("d-none"))
        QR_ModalPanel.classList.remove("d-none")
    else
        QR_ModalPanel.classList.add("d-none")

}
